/** Llamadas HTTP de lecturas (vista admin / directiva). */
import { apiRequest } from "../../lib/api";

export type TipoLectura = "Real" | "Estimada" | "Ajuste";
export type EstadoLectura =
  | "Pendiente"
  | "Emitida"
  | "Pagada"
  | "Vencida"
  | "Anulada";

export interface LecturaRead {
  id: number;
  empresa_id: number;
  contrato_id: number;
  medidor_id: number | null;
  mes: number;
  anio: number;
  fecha_lectura: string | null;
  fecha_ingreso: string | null;
  fecha_vencimiento: string | null;
  tipo_lectura: TipoLectura;
  motivo_estimada: string | null;
  observaciones: string | null;
  lectura_anterior: number;
  lectura_actual: number;
  consumo_m3: number;
  monto_cargo_fijo: number;
  monto_consumo: number;
  monto_alcantarillado: number;
  monto_subsidio: number;
  monto_multas: number;
  monto_total: number;
  saldo_anterior: number;
  estado: EstadoLectura;
  flag_revision: boolean;
  numero_boleta: string | null;
  codigo_barras: string | null;
  motivo_anulacion: string | null;
  fecha_anulacion: string | null;
  tomado_por_id: number | null;
}

export interface LecturasFilter {
  mes: number;
  anio: number;
  sector_id?: number | null;
  incluir_anuladas?: boolean;
}

export function listarLecturas(f: LecturasFilter): Promise<LecturaRead[]> {
  const params = new URLSearchParams({
    mes: String(f.mes),
    anio: String(f.anio),
  });
  if (f.sector_id != null) params.set("sector_id", String(f.sector_id));
  if (f.incluir_anuladas) params.set("incluir_anuladas", "true");
  return apiRequest<LecturaRead[]>(`/api/v1/lecturas?${params.toString()}`);
}

// ────────────────────────────────────────────────────────────────────────
// Acciones de la oficina sobre una lectura (recorrido R1)
// ────────────────────────────────────────────────────────────────────────

export interface TomarLecturaPayload {
  contrato_id: number;
  mes: number;
  anio: number;
  lectura_actual: number;
  fecha_lectura?: string | null;
  tipo_lectura?: TipoLectura;
  motivo_estimada?: string | null;
}

/** Alta manual desde la oficina: muchos comités leen en papel y digitan. */
export function crearLectura(payload: TomarLecturaPayload): Promise<LecturaRead> {
  return apiRequest<LecturaRead>("/api/v1/lecturas", {
    method: "POST",
    body: payload,
  });
}

export function anularLectura(id: number, motivo: string): Promise<LecturaRead> {
  return apiRequest<LecturaRead>(`/api/v1/lecturas/${id}/anular`, {
    method: "POST",
    body: { motivo },
  });
}

export interface CorregirLecturaPayload {
  lectura_actual: number;
  motivo: string;
  tipo_lectura?: TipoLectura;
  motivo_estimada?: string | null;
}

/** Anula la lectura y crea su reemplazo: devuelve la **nueva**. */
export function corregirLectura(
  id: number,
  payload: CorregirLecturaPayload,
): Promise<LecturaRead> {
  return apiRequest<LecturaRead>(`/api/v1/lecturas/${id}/corregir`, {
    method: "POST",
    body: payload,
  });
}

export function marcarRevision(
  id: number,
  flagRevision: boolean,
  observacion?: string,
): Promise<LecturaRead> {
  return apiRequest<LecturaRead>(`/api/v1/lecturas/${id}/revision`, {
    method: "POST",
    body: { flag_revision: flagRevision, observacion: observacion ?? null },
  });
}
